
import { defineComponent } from "vue";

export default defineComponent({
  name: "OrientationPopup",
  data: () => ({
    showModal: false
  }),
  mounted() {
    window.showOrHideOrientationPopup = (show: boolean) => {
      this.showModal = show;
    }
  }
});
